<div [class.notification-dot--active]="isActive" class="notification-dot">
  <ng-content></ng-content>
</div>
